import {Component, EventEmitter, OnDestroy, inject, Input, OnInit, Output, signal} from '@angular/core';
import {CustomMessageService, UtilService, CountdownTimerService, CountdownTick} from "library";
import {RequestService} from "projects/store/src/app/services/api/v1/request.service";
import {ActivatedRoute} from "@angular/router";
import {HttpErrorResponse, HttpStatusCode} from "@angular/common/http";

@Component({
  selector: 'app-sales-exito-evertec',
  templateUrl: './sales-exito-evertec.component.html',
  styles: [
  ]
})
export class SalesExitoEvertecComponent implements OnInit, OnDestroy{
  @Input() typePointSales: any;
  @Output() nextStepEvent = new EventEmitter();

  private  readonly utilService = inject(UtilService);
  private  readonly requestService = inject(RequestService);
  private  readonly customMessageService = inject(CustomMessageService);
  private readonly route = inject(ActivatedRoute);

  isLoading  = signal(false);
  isError  = signal(false);
  visibleModal = false;
  requestId: string;
  status: number = HttpStatusCode.Ok;
  httpResponseStatusCodes = {
    OK: HttpStatusCode.Ok,
  };
  readonly categoryCode = this.route.snapshot.params['category_code'];
  data = signal<any>({});

  timeNewCodeSending!: { minutes: number, seconds: number };
  private countdownSub: any;
  private finishedSub: any;
  buttonEnabled = false;

  constructor() {
    this.requestId = this.route.snapshot.params['request_id'];

  }

  ngOnInit() {
    this.load();
    this.data.set(this.requestService.request);
  }

  load(){
    this.utilService.disablePageLoading();
    this.isLoading.set(true);
    this.requestService.createCashDeposit(this.requestId).subscribe({
      next: (resp)=> {
        if (resp.status == HttpStatusCode.NoContent) {
          this.showModal();
        }else{
          this.customMessageService.responseError();
        }

        this.isLoading.set(false);
      },
      error: (err: HttpErrorResponse)=> {
        if (err.status == HttpStatusCode.NotAcceptable) {

          this.isError.set(true);
          this.startCountdown();
        }else{
          this.customMessageService.comunicationError();
        }

      },
    })


  }

  startCountdown() {
    this.buttonEnabled = false;
    // Cancelar suscripciones previas
    this.countdownSub?.unsubscribe?.();
    this.finishedSub?.unsubscribe?.();
    // Duración de 120s
    const duration = { minutes: Math.floor(120 / 60), seconds: 120 % 60 };
    this.timeNewCodeSending = { ...duration };
    // Iniciar servicio
    const countdown = inject(CountdownTimerService);
    countdown.startWithDuration(duration);
    // Suscribir a ticks y finalización
    this.countdownSub = countdown.tick$.subscribe((tick: CountdownTick) => {
      this.timeNewCodeSending = { ...tick };
    });
    this.finishedSub = countdown.finished$.subscribe(() => {
      this.buttonEnabled = true;
      this.isLoading.set(false);
    });
  }


  get formattedTime(): string {
    const minutes = (this.timeNewCodeSending?.minutes ?? 0).toString().padStart(2, '0');
    const seconds = (this.timeNewCodeSending?.seconds ?? 0).toString().padStart(2, '0');
    return `${minutes}:${seconds} segundos`;
  }


  onNextStep() {
    this.utilService.enablePageLoading();
    this.nextStepEvent.emit();
  }

  showModal(){
    this.visibleModal = true;
  }

  onRetry(){
    this.status = HttpStatusCode.Ok;
    this.load();
  }

  ngOnDestroy(): void {
    this.countdownSub?.unsubscribe?.();
    this.finishedSub?.unsubscribe?.();
    try {
      const countdown = inject(CountdownTimerService);
      countdown.stop();
    } catch {}
  }
}
